import Contacts from "../reusables/Contacts";
const ContactBody = () => {
  return (
    <section className="page contact box-shadow">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="page-head section-spacing-20 width-800 margin-auto">
              <p className="page-content-subtitle">
                We're here to help 24/7. Discuss your web, digital, and ICT
                needs and inquiries with our team of experts.
              </p>
            </div>
            <div className="section-spacing-50 no-padding-top">
              <Contacts /> 
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactBody;
